import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './ShopDiscoverResults.scss';

import { syncShopFeatures } from '../../Actions/FeaturedActions';
import { getShopFeaturedResultsForType, getFeaturedTypeDisplayData } from '../../Helpers/featured_helpers';

import ShopTile from '../Shop/ShopTile';
import ShopFeaturesAddNewButton from './Elements/ShopFeaturesAddNewButton';

const ShopDiscoverResults = props => {
  const results = getShopFeaturedResultsForType(props.featured, props.tab, props.activeSection);
  const displayData = getFeaturedTypeDisplayData(props.tab);
  // Pattern-driven row structure: specify type and group sizes only
  const rowPattern = [
    { type: 'has-feature first', groups: [1, 4] },
    { type: 'row', groups: [4] },
    { type: 'has-feature last', groups: [4, 1] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] },
    { type: 'row', groups: [4] }
  ];

  // Smartly generate rows based on the pattern
  let cursor = 0;
  const rows = rowPattern
    .map(pattern => {
      const row_results = pattern.groups.map(groupSize => {
        const group = results.slice(cursor + 1, cursor + groupSize + 1); // First one should be a feature
        cursor += groupSize;
        return group;
      });
      return { type: pattern.type, row_results };
    })
    .filter(row => _.flatten(row.row_results).length);

  return (
    <div className='shop-discover-results-container'>
      <div className='results-header'>
        <div className='line line-left' />
        <div className='label'>Featured {displayData.pluralType}</div>
        <div className='line line-right' />
      </div>
      <div className='shop-discover-results'>
        {rows.map(row => {
          const { row_results, type } = row;
          if (!row_results?.length) return null;
          return (
            <div key={row.type} className={cn('row', type)}>
              {row_results.map(tiles => {
                if (!tiles.length) return null;
                return (
                  <div className={cn('row-tiles', type)} key={tiles[0].id}>
                    {tiles.map(feature => {
                      const isFeature = tiles.length === 1;
                      return (
                        <div className={cn('tile', { feature: isFeature })} key={feature.id}>
                          {feature?.id ? (
                            <ShopTile
                              featured={props.featured}
                              feature={feature}
                              activeSection={props.activeSection}
                              syncShopFeatures={props.syncShopFeatures}
                              eventSource='Shop Discover'
                            />
                          ) : (
                            <div className='tile-placeholder' />
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      {window.__ADMIN_CONTROL_MODE__ && (
        <div className='admin-section'>
          <ShopFeaturesAddNewButton type={props.tab} />
        </div>
      )}
    </div>
  );
};

ShopDiscoverResults.propTypes = {
  featured: PropTypes.object.isRequired,

  // From Outside
  tab: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(ShopDiscoverResults);
